var map = {
	"./edu.png": "b462",
	"./example.png": "1da5",
	"./join.png": "4fff",
	"./learn.png": "ba1d",
	"./local.png": "ef77",
	"./new.png": "ef95",
	"./party.png": "505b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a29c";